module.exports = __webpack_public_path__ + "img/36-image-1@2x.1577e66b.png";